import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import { AuditLogService } from '../audit-log.service';

export const LATEST_AUDIT_LOGS_COUNT = 5;
export const MODAL_LATEST_AUDIT_LOGS_COUNT = 10;
export const LATEST_AUDIT_LOGS_POLL_MS = 5_000;

export const useGetAuditLogs = (
	params: AuditLogs.AuditLogListParams,
	options?: Omit<
		UseQueryOptions<AuditLogs.AuditLogListResponse, Error>,
		'queryKey' | 'queryFn'
	>,
) => {
	return useQuery({
		queryKey: ['audit-logs', params],
		queryFn: () => AuditLogService.get(params),
		refetchOnWindowFocus: false,
		...options,
	});
};

export const useGetLatestAuditLogs = (
	params: AuditLogs.AuditLogLatestParams = { last: LATEST_AUDIT_LOGS_COUNT },
	options?: Omit<
		UseQueryOptions<AuditLogs.AuditLogLatestListResponse, Error>,
		'queryKey' | 'queryFn'
	>,
) => {
	return useQuery({
		queryKey: ['audit-logs', 'latest', params],
		queryFn: () => AuditLogService.getLatest(params),
		refetchInterval: LATEST_AUDIT_LOGS_POLL_MS,
		refetchOnWindowFocus: true,
		...options,
	});
};
